module.exports = __webpack_public_path__ + "img/no-past-events.0be65cfa.svg";